/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AutoCollectedIds
 */
export interface AutoCollectedIds {
    /**
     * 
     * @type {string}
     * @memberof AutoCollectedIds
     */
    readonly collectedIds?: string;
}

/**
 * Check if a given object implements the AutoCollectedIds interface.
 */
export function instanceOfAutoCollectedIds(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AutoCollectedIdsFromJSON(json: any): AutoCollectedIds {
    return AutoCollectedIdsFromJSONTyped(json, false);
}

export function AutoCollectedIdsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutoCollectedIds {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'collectedIds': !exists(json, 'collected_ids') ? undefined : json['collected_ids'],
    };
}

export function AutoCollectedIdsToJSON(value?: AutoCollectedIds | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

